export default {
	"11cf0b7b5c6a61c5511eba645594c1bb": "No payment result was detected",
	"07b0bca0c86195467d293061e8132870": "If payment has been made, please click \"Refresh\" to check the result",
	"2396ccabf52cb680fb975e1f849f9f02": "Refresh",
	"cabd57357355e6d6c246880542cf7910": "Re-payment"
}
